import React from "react";
import Icons from "../../../assets/icons";

const UserDetail = ({profileDetails={}}) => {
    return (
    <div className="user_picture d-flex align-items-center">
        <figure className="user_img">
            <img src={profileDetails?.avatar || Icons.Avatar} alt="Profile" className="img-fluid" />
        </figure>
        <div className="user_name">
            <p>{profileDetails?.name}</p>
        </div>
    </div>
    )
}

export default UserDetail